var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.OCSDateTimeMobileOps = {
    time_duration_millsecs: 15 * 60 * 1000 * 1,
    animation_loop_length: 15 * 61 * 1000 * 1 // length of time in milliseconds for the entire animation loop (default 1 hour and 1 minute)
};
